import React from 'react';
import { Box, Typography,Badge } from '@mui/joy';
import { CssVarsProvider } from '@mui/joy/styles';
const DiscountLabel = ({ sale }) => {
  const [oldPrice, discountPercentage] = sale.split('%');
  const newPrice = (oldPrice - (oldPrice * (discountPercentage / 100))).toFixed(0);
  return (
    <CssVarsProvider>
    <Box display="flex" alignItems="baseline">
      {discountPercentage ? (
        <>
          <Badge 
          badgeContent={<Typography variant='outlined' color='#ffffff' sx={{ border:0, fontSize: { xs: 12, sm: 13, md: 16 }}}>{newPrice + '€'}</Typography>}
          sx={{border:'0'}}  
          color='success'
          >
            <Typography 
              variant="solid" 
              level='body-sm'
              color='danger' 
              sx={{ textDecoration: 'line-through', marginRight: 1, borderRadius: 5, fontSize: { xs: 12, sm: 13, md: 16 } }}
            >
              {oldPrice} €
            </Typography>
          </Badge>
    
        </>
      ) : (
        <Typography
          color='success'
          variant='solid'
          sx={{ borderRadius: 5, fontSize: { xs: 12, sm: 13, md: 16 } }}
        >
          {oldPrice} €
        </Typography>
      )}
    </Box>
    </CssVarsProvider>
  );
};

export default DiscountLabel;